'use client'

import React, { FC, ReactElement } from 'react'
import styles from './CreateWalletFooter.module.css'
import Button from '@/components/button'
import Loading from '@/components/circle-loading'
import { CREATE_WALLET_STEPS, RESTORE_WALLET_STEPS } from '../constants'
import classNames from 'classnames'

const CreateWalletFooter: FC<{
	step: number
	nextDisabled: boolean
	onNext: (evt: any) => void
	onBack: (evt: any) => void
	restore?: boolean
	loading?: boolean
}> = ({ step, nextDisabled, onNext, onBack, restore, loading }): ReactElement => {
	const stepData = React.useMemo(
		() => (restore ? RESTORE_WALLET_STEPS[step] : CREATE_WALLET_STEPS[step]),
		[restore, step]
	)

	return (
		<div className={styles.root}>
			{stepData.disclaimer && (
				<p className={classNames(styles.disclaimer, 'text-md', 'regular')}>{stepData.disclaimer}</p>
			)}
			<Button
				onClick={onNext}
				className={styles.primaryButton}
				disabled={nextDisabled || loading}
				type="submit"
				size="small"
				background="white"
			>
				{loading ? <Loading /> : stepData.primaryButton}
			</Button>
			{stepData.secondaryButton && (
				<Button background="transparent" onClick={onBack} className={styles.secondaryButton}>
					{stepData.secondaryButton}
				</Button>
			)}
		</div>
	)
}

export default CreateWalletFooter
